import { httpClient } from '@/shared/api';

const PREFIX = '/app/dashboard-setting';

export interface DashboardSettingDto {
  id: string;
  name: string;
  value: string;
}

function mapDashboardSetting(raw: unknown): DashboardSettingDto | null {
  if (!raw || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const id = String(o.id ?? o.Id ?? '').trim();
  const name = String(o.name ?? o.Name ?? '').trim();
  const value = String(o.value ?? o.Value ?? '').trim();
  if (!id || !name) return null;
  return { id, name, value };
}

function normalizeListResponse(raw: unknown): DashboardSettingDto[] {
  if (!raw || typeof raw !== 'object') return [];
  const o = raw as Record<string, unknown>;
  const rawItems = (o.items ?? o.Items) as unknown[] | undefined;
  if (!Array.isArray(rawItems)) return [];
  return rawItems.map(mapDashboardSetting).filter((x): x is DashboardSettingDto => x != null);
}

export const dashboardSettingsApi = {
  getAll: async (): Promise<DashboardSettingDto[]> => {
    const q = new URLSearchParams();
    q.set('SkipCount', '0');
    q.set('MaxResultCount', '1000');
    const res = await httpClient.get<unknown>(`${PREFIX}?${q.toString()}`);
    return normalizeListResponse(res);
  },

  getByName: async (name: string): Promise<DashboardSettingDto | null> => {
    const q = new URLSearchParams();
    q.set('Name', name);
    q.set('SkipCount', '0');
    q.set('MaxResultCount', '1');
    const res = await httpClient.get<unknown>(`${PREFIX}?${q.toString()}`);
    return normalizeListResponse(res)[0] ?? null;
  },

  update: async (id: string, body: { name: string; value: string }): Promise<DashboardSettingDto> => {
    const res = await httpClient.put<unknown>(`${PREFIX}/${id}`, body);
    return mapDashboardSetting(res) ?? { id, name: body.name, value: body.value };
  },
};
